<template>

  <base-modal name="project-accounting-item-edit"
              :width="400"
              toptitle="Buchung bearbeiten"
              :title="projectAccountingItem.title || projectAccountingItem.description"
              :subtitle="updated"
              v-on="$listeners"
              v-bind="$attrs">
      <project-accounting-item-form :projectAccountingItem="projectAccountingItem" type="edit"/>
  </base-modal>

</template>

<script>
import ProjectAccountingItemForm from './ProjectAccountingItemForm.vue'
import moment from 'moment/moment'

export default {
  name: 'ProjectAccountingItemEdit',
  components: { ProjectAccountingItemForm },
  props: {
    projectAccountingItem: Object
  },
  computed: {
    costCenterLabel () {
      switch (this.projectAccountingItem.costCenter) {
        case 1:
          return 'PR'
        case 2:
          return 'Social Media'
        case 3:
          return 'Marketing'
        default:
          return ''
      }
    },
    updated () {
      return `${this.projectAccountingItem.updatedBy.firstName} ${moment(this.projectAccountingItem.updatedAt).fromNow()}`
    }
  }
}
</script>
